/**
 * @file Album onboarding start landing page / schools.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../util/assets';
import { getAccountCheckoutGreetingName } from '../../../util/account';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func,
  isFreeJoin: PropTypes.func,
};

const OnboardingLandingSchools = ({
  albumFolder,
  onGetStarted,
  isFreeJoin,
}) => {
  const displayName = getAccountCheckoutGreetingName(albumFolder.account);

  return (
    <OnboardingLayoutContentNarrow>
      <h4 className="mb-1 text-center">Welcome to</h4>
      <h2 className="text-black mb-1 text-center">{albumFolder.name}!</h2>
      {displayName && <p className="text-sm">By {displayName}</p>}

      <p className="text-center">
        {displayName ? (
          <span>Welcome to Waldo at {displayName}</span>
        ) : (
          'Welcome to Waldo'
        )}
        , a secure new photo delivery service powered by facial recognition.
      </p>

      <p className="text-center">
        It&rsquo;s easy! You submit a reference photo of your student. Waldo
        sends you all their best school moments!
      </p>

      <img
        src={getAsset('/waldo-way.png')}
        height="140px"
        className="my-2"
        alt="Waldo Way"
      />
      <Button onClick={onGetStarted} className="mt-2" btnBlock>
        {isFreeJoin ? 'Join for FREE Today!' : "Let's Get Started!"}
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms of Use
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

OnboardingLandingSchools.propTypes = propTypes;

export default OnboardingLandingSchools;
